module.exports = __webpack_public_path__ + "static/fonts/Mont-LightItalic.4be1ceb.ttf";